import List from "@/views/MGT/Corpcircle/List";
import STree from "@/views/MGT/Corpcircle/Stree";
import Detail from "@/views/MGT/Corpcircle/Detail";
export default {
  name: "interconnection",
  components: {
    List,
    STree,
    Detail
  },
  data() {
    return {
      search: {
        value: ""
      },
      org: {
        id: "",
        actionValue: "1" // '1'：代表列表, '2': 代表详情
      },
      inter: {
        item: {}
      }
    };
  },
  computed: {
    showList() {
      return this.org.actionValue === "1";
    },
    showUserDetail() {
      return this.org.actionValue === "2";
    }
  },
  methods: {
    clearSearchValue() {
      this.search.value = "";
    },
    onSearchList() {},
    openModal(key) {
      switch (key) {
        case "add":
          break;
        default:
          break;
      }
    },
    changeDetail(item) {
      this.inter.item = {
        ...item
      };
      this.changeAction("2");
    },
    changeAction(key, search) {
      let org = {
        ...this.org,
        ...{
          actionValue: key
        }
      };
      this.changeOrg(org);
      if (search) {
        // this.onSearchByUser();
      }
    },
    changeOrg(org) {
      this.org = org;
    }
  }
};